import { useAuth } from 'q3-ui-permissions';
import { COLLECTIONS } from './constants';

export default () =>
  useAuth(COLLECTIONS.ORDERS.COLLECTION_NAME);
